module.exports = __webpack_public_path__ + "img/bulgaria.cd090bb6.svg";